<template>
  <form :class="{ 'service-form--small': small }" @submit.prevent>
    <div>
      <div class="row">
        <div class="col col-12">
          <LocalGrouperServiceForm
            :application="application"
            :service-type="serviceType"
            :default-values="defaultValues"
            :enable-integration-picker="enableIntegrationPicker"
            @values-changed="values = { ...values, ...$event }"
          ></LocalGrouperServiceForm>
        </div>
      </div>
      <div v-if="values.integration_id && values.table_id" class="row">
        <div class="col col-6">
          <FormGroup
            small-label
            :label="$t('localGrouperGetRowForm.rowFieldLabel')"
            required
          >
            <InjectedFormulaInput
              v-model="values.row_id"
              :placeholder="$t('localGrouperGetRowForm.rowFieldPlaceHolder')"
            />
            <template #helper>
              {{ $t('localGrouperGetRowForm.rowFieldHelpText') }}
            </template>
          </FormGroup>
        </div>
      </div>
      <ServiceRefinementForms
        v-if="!fieldsLoading && values.table_id"
        class="margin-top-2"
        :small="small"
        :values="values"
        :table-fields="tableFields"
        show-filter
        show-search
      />
      <div v-if="fieldsLoading" class="loading-spinner"></div>
    </div>
  </form>
</template>

<script>
import form from '@grouper/modules/core/mixins/form'
import InjectedFormulaInput from '@grouper/modules/core/components/formula/InjectedFormulaInput'
import localGrouperService from '@grouper/modules/integrations/localGrouper/mixins/localGrouperService'
import LocalGrouperServiceForm from '@grouper/modules/integrations/localGrouper/components/services/LocalGrouperServiceForm'
import ServiceRefinementForms from '@grouper/modules/integrations/localGrouper/components/services/ServiceRefinementForms'

export default {
  components: {
    LocalGrouperServiceForm,
    InjectedFormulaInput,
    ServiceRefinementForms,
  },
  mixins: [form, localGrouperService],
  data() {
    return {
      allowedValues: [
        'table_id',
        'view_id',
        'row_id',
        'search_query',
        'filters',
        'filter_groups',
        'filter_type',
      ],
      values: {
        table_id: null,
        view_id: null,
        row_id: {},
        search_query: {},
        filters: [],
        filter_groups: [],
        filter_type: 'AND',
      },
    }
  },
}
</script>
